<template>
  <ReportChartCard :title="t('report.charts.demand')">
    <VueApexCharts class="bg-white" type="bar" :options="chartOptions" :series="series" height="400" />
  </ReportChartCard>
</template>

<script setup lang="ts">
import { useI18n } from '@/composable/useI18n'
import { useReportStore } from '@/store/report'
import { useDemandChart } from '@/utils/components/demand-chart'
import VueApexCharts from 'vue3-apexcharts'
import ReportChartCard from './ReportChartCard.vue'

const { t } = useI18n()
const store = useReportStore()

const { chartOptions, series } = useDemandChart(store.getEnergySensorDemand, store.getCompareEnergySensorDemand)
</script>
